import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "grid productInfoGrid mt-5" }
const _hoisted_2 = { class: "col mt-5" }
const _hoisted_3 = { class: "text-color-um-blue" }
const _hoisted_4 = { class: "col mt-5" }
const _hoisted_5 = { class: "text-color-um-blue" }
const _hoisted_6 = { class: "grid productInfoGrid mt-5" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = {
  key: 0,
  class: ""
}
const _hoisted_9 = { class: "text-color-um-blue" }
const _hoisted_10 = { class: "product__accordion" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  key: 0,
  class: ""
}
const _hoisted_14 = { class: "text-color-um-blue" }
const _hoisted_15 = { class: "product__accordion" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "grid productInfoGrid mt-5" }
const _hoisted_18 = { class: "col" }
const _hoisted_19 = {
  key: 0,
  class: ""
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_22 = { style: {"font-size":"18px"} }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_24 = { class: "col" }
const _hoisted_25 = {
  key: 0,
  class: ""
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_28 = { style: {"font-size":"18px"} }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "icon-chevron-right" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_31 = { class: "grid productInfoGrid mt-5" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_34 = { class: "text-color-um-blue" }
const _hoisted_35 = { class: "mt-5" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "text-color-um-blue" }
const _hoisted_38 = { class: "mt-5" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "text-color-um-blue" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_43 = { class: "text-color-um-blue" }
const _hoisted_44 = { class: "mt-5" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "text-color-um-blue" }
const _hoisted_47 = { class: "mt-5" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "text-color-um-blue" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_51 = { class: "grid productInfoGrid mt-5" }
const _hoisted_52 = { class: "col" }
const _hoisted_53 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_54 = { class: "text-color-um-blue" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_62 = { class: "text-color-um-blue" }
const _hoisted_63 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_64 = { class: "text-color-um-blue" }
const _hoisted_65 = {
  key: 3,
  class: "mt-5"
}
const _hoisted_66 = { class: "text-color-um-blue" }
const _hoisted_67 = {
  key: 4,
  class: "mt-5"
}
const _hoisted_68 = { class: "text-color-um-blue" }
const _hoisted_69 = { class: "col" }
const _hoisted_70 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_71 = { class: "text-color-um-blue" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_78 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_79 = { class: "text-color-um-blue" }
const _hoisted_80 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_81 = { class: "text-color-um-blue" }
const _hoisted_82 = {
  key: 3,
  class: "mt-5"
}
const _hoisted_83 = { class: "text-color-um-blue" }
const _hoisted_84 = {
  key: 4,
  class: "mt-5"
}
const _hoisted_85 = { class: "text-color-um-blue" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_87 = { class: "grid productInfoGrid mt-5" }
const _hoisted_88 = { class: "col" }
const _hoisted_89 = { class: "mt-5" }
const _hoisted_90 = { class: "text-color-um-blue" }
const _hoisted_91 = { class: "col" }
const _hoisted_92 = { class: "mt-5" }
const _hoisted_93 = { class: "text-color-um-blue" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_95 = { class: "grid productInfoGrid mt-5" }
const _hoisted_96 = { class: "col" }
const _hoisted_97 = { class: "mt-5" }
const _hoisted_98 = { class: "text-color-um-blue" }
const _hoisted_99 = { class: "mt-5" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_101 = { class: "col" }
const _hoisted_102 = { class: "mt-5" }
const _hoisted_103 = { class: "text-color-um-blue" }
const _hoisted_104 = { class: "mt-5" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("hr", { class: "my-5" }, null, -1)
const _hoisted_107 = { class: "grid productInfoGrid mt-5" }
const _hoisted_108 = { class: "col j-center" }
const _hoisted_109 = { class: "col j-center" }
const _hoisted_110 = ["src", "alt"]
const _hoisted_111 = ["src", "alt"]
const _hoisted_112 = ["src", "alt"]
const _hoisted_113 = ["src", "alt"]
const _hoisted_114 = {
  class: "text-left",
  style: {"max-width":"295px","margin":"0 auto"}
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!
  const _component_GoogleMapsSmall = _resolveComponent("GoogleMapsSmall")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Galleria = _resolveComponent("Galleria")!
  const _component_Prompt = _resolveComponent("Prompt")!
  const _component_Register = _resolveComponent("Register")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.state.item1 && _ctx.state.item2)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(_ctx.state.class)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.state.item1.name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.state.item1.accessPurposeDescription), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.state.item1.technicalCharacteristic), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.state.item2.name), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.state.item2.accessPurposeDescription), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.state.item2.technicalCharacteristic), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.state.item1.components)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentComponentTitle")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      (_ctx.state.item1.components)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(_component_Accordion, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item1.components, (child, index_child) => {
                                  return (_openBlock(), _createBlock(_component_AccordionTab, {
                                    key: index_child,
                                    header: child.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.description), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.state.item2.components)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentComponentTitle")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      (_ctx.state.item2.components)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_Accordion, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item2.components, (child, index_child) => {
                                  return (_openBlock(), _createBlock(_component_AccordionTab, {
                                    key: index_child,
                                    header: child.name
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(child.description), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["header"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_ctx.state.images1[0])
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "absImgBG",
                      style: _normalizeStyle([
              _ctx.state.productImage1
                ? 'background-image:url(' + _ctx.state.productImage1 + ')'
                : '',
            ])
                    }, [
                      _createElementVNode("img", {
                        style: {"height":"308px","width":"460px"},
                        src: _ctx.state.images1[0].url,
                        alt: "Equipment image"
                      }, null, 8, _hoisted_20)
                    ], 4),
                    (_ctx.state.images1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "read-more text-color-blue mt-2",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.state.showGallery1 = true), ["prevent"]))
                          }, [
                            _createElementVNode("strong", _hoisted_22, _toDisplayString(_ctx.t("content.researchEquipment.content.photoGalleryTitle")) + "...", 1),
                            _hoisted_23
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_ctx.state.images2[0])
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", {
                      class: "absImgBG",
                      style: _normalizeStyle([
              _ctx.state.productImage2
                ? 'background-image:url(' + _ctx.state.productImage2 + ')'
                : '',
            ])
                    }, [
                      _createElementVNode("img", {
                        style: {"height":"308px","width":"460px"},
                        src: _ctx.state.images2[0].url,
                        alt: "Equipment image"
                      }, null, 8, _hoisted_26)
                    ], 4),
                    (_ctx.state.images2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "read-more text-color-blue mt-2",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.state.showGallery2 = true), ["prevent"]))
                          }, [
                            _createElementVNode("strong", _hoisted_28, _toDisplayString(_ctx.t("content.researchEquipment.content.photoGalleryTitle")) + "...", 1),
                            _hoisted_29
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              (_ctx.state.item1.researchOrganization?.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.state.item1.contactUsers[0])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", _hoisted_34, _toDisplayString(_ctx.t("content.researchEquipment.content.responsiblePersonTitle")), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-user",
                                label: _ctx.state.responsibleUserContact1.name
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-phone",
                                label: _ctx.state.responsibleUserContact1.mobile
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-envelope-3",
                                label: _ctx.state.responsibleUserContact1.email
                              }, null, 8, ["label"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_35, [
                      (_ctx.state.item1.researchOrganization)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                            _createElementVNode("strong", _hoisted_37, _toDisplayString(_ctx.t(
                  "content.researchEquipment.content.memberOfTheUniversityOfMariborTitle"
                )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "icon-pin",
                            label: `${_ctx.state.item1.researchOrganization.name} 
                   <br/> ${_ctx.state.item1.location?.street} 
                   <br/> ${_ctx.state.item1.location?.postalCode}`
                          }, null, 8, ["label"])
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "icon-pin",
                            label: `${_ctx.state.item1.location?.departments[0]?.name}`
                          }, null, 8, ["label"])
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "pi pi-link",
                            label: _ctx.state.item1.researchOrganization.websiteURL,
                            href: _ctx.state.item1.researchOrganization.id
                          }, null, 8, ["label", "href"])
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_38, [
                (_ctx.state.item1.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", _hoisted_40, _toDisplayString(_ctx.t("content.researchEquipment.content.locationTitle")), 1)
                      ]),
                      _createVNode(_component_GoogleMapsSmall, {
                        location: _ctx.locationPosition1()
                      }, null, 8, ["location"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              (_ctx.state.item2.researchOrganization?.name)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.state.item2.contactUsers[0])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                          _createElementVNode("p", null, [
                            _createElementVNode("strong", _hoisted_43, _toDisplayString(_ctx.t("content.researchEquipment.content.responsiblePersonTitle")), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-user",
                                label: _ctx.state.responsibleUserContact2.name
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-phone",
                                label: _ctx.state.responsibleUserContact2.mobile
                              }, null, 8, ["label"])
                            ]),
                            _createElementVNode("p", null, [
                              _createVNode(_component_IconTextBlock, {
                                icon: "icon-envelope-3",
                                label: _ctx.state.responsibleUserContact2.email
                              }, null, 8, ["label"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_44, [
                      (_ctx.state.item2.researchOrganization)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                            _createElementVNode("strong", _hoisted_46, _toDisplayString(_ctx.t(
                  "content.researchEquipment.content.memberOfTheUniversityOfMariborTitle"
                )), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "icon-pin",
                            label: `${_ctx.state.item2.researchOrganization.name} 
                   <br/> ${_ctx.state.item2.location?.street} 
                   <br/> ${_ctx.state.item2.location?.postalCode}`
                          }, null, 8, ["label"])
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "icon-pin",
                            label: `${_ctx.state.item2.location?.departments[0]?.name}`
                          }, null, 8, ["label"])
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_IconTextBlock, {
                            icon: "pi pi-link",
                            label: _ctx.state.item2.researchOrganization.websiteURL,
                            href: _ctx.state.item2.researchOrganization.id
                          }, null, 8, ["label", "href"])
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_47, [
                (_ctx.state.item2.location)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _createElementVNode("p", null, [
                        _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.t("content.researchEquipment.content.locationTitle")), 1)
                      ]),
                      _createVNode(_component_GoogleMapsSmall, {
                        location: _ctx.locationPosition2()
                      }, null, 8, ["location"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _hoisted_50,
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              (_ctx.state.item1.equipmentCriteria)
                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_54, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationMERIL")), 1),
                      _hoisted_55,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item1.equipmentCriteria[_ctx.state.localProperty]), 1),
                      _hoisted_56,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationUNILeeds")), 1),
                      _hoisted_57,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item1.equipmentUniLeedClassType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_58,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item1.equipmentUniLeedOrderType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_59,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item1.equipmentUniLeedType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_60
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item1.equipmentAccessType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_62, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessTypeTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item1.equipmentAccessType[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item1.equipmentAccessMethod)
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_64, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessMethodsTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item1.equipmentAccessMethod[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item1.equipmentLifeCycleStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_66, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.lifeCycleStatusOfEquipment")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item1.equipmentLifeCycleStatus[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item1.equipmentTargetGroups)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_68, _toDisplayString(_ctx.t("content.researchEquipment.content.targetUserGroupTitle")), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item1.equipmentTargetGroups, (targetUser) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: targetUser.id
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(targetUser[_ctx.state.localProperty]), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_69, [
              (_ctx.state.item2.equipmentCriteria)
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_71, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationMERIL")), 1),
                      _hoisted_72,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item2.equipmentCriteria[_ctx.state.localProperty]), 1),
                      _hoisted_73,
                      _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.researchEquipment.content.classificationUNILeeds")), 1),
                      _hoisted_74,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item2.equipmentUniLeedClassType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_75,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item2.equipmentUniLeedOrderType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_76,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.item2.equipmentUniLeedType[_ctx.state.localProperty]) + " ", 1),
                      _hoisted_77
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item2.equipmentAccessType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_79, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessTypeTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item2.equipmentAccessType[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item2.equipmentAccessMethod)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_81, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.accessMethodsTitle")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item2.equipmentAccessMethod[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item2.equipmentLifeCycleStatus)
                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_83, _toDisplayString(_ctx.t("content.researchEquipment.sidebar.lifeCycleStatusOfEquipment")), 1)
                    ]),
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.state.item2.equipmentLifeCycleStatus[_ctx.state.localProperty]), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.item2.equipmentTargetGroups)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("p", null, [
                      _createElementVNode("strong", _hoisted_85, _toDisplayString(_ctx.t("content.researchEquipment.content.targetUserGroupTitle")), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.item2.equipmentTargetGroups, (targetUser) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: targetUser.id
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(targetUser[_ctx.state.localProperty]), 1)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_86,
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_90, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentAccessTypeTitle")), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.state.item1.accessTypeDescription), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_93, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentAccessTypeTitle")), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.state.item2.accessTypeDescription), 1)
              ])
            ])
          ]),
          _hoisted_94,
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_98, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentUserPriceListTitle")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(_component_DataTable, {
                  value: _ctx.state.item1.researchEquipmentPrice
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "userExpertiseLevel",
                      header: 
                _ctx.t('content.researchEquipment.content.priceListUserHeaderTitle')
              
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.t(
                    `content.researchEquipment.priceListExperienceLevel.` +
                      slotProps.data.userExpertiseLevel
                  )), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, { field: "date_1" }, {
                      header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListDateRangeTitle")), 1)
                      ]),
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.dateFrom)) + " ", 1),
                        _hoisted_100,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(slotProps.data.dateTo)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "date_2" }, {
                      header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListPriceHeaderTitle")), 1)
                      ]),
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.price) + " € ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("p", null, [
                  _createElementVNode("strong", _hoisted_103, _toDisplayString(_ctx.t("content.researchEquipment.content.equipmentUserPriceListTitle")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createVNode(_component_DataTable, {
                  value: _ctx.state.item2.researchEquipmentPrice
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "userExpertiseLevel",
                      header: 
                _ctx.t('content.researchEquipment.content.priceListUserHeaderTitle')
              
                    }, {
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.t(
                    `content.researchEquipment.priceListExperienceLevel.` +
                      slotProps.data.userExpertiseLevel
                  )), 1)
                      ]),
                      _: 1
                    }, 8, ["header"]),
                    _createVNode(_component_Column, { field: "date_1" }, {
                      header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListDateRangeTitle")), 1)
                      ]),
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(slotProps.data.dateFrom)) + " ", 1),
                        _hoisted_105,
                        _createTextVNode(" " + _toDisplayString(_ctx.formatDate(slotProps.data.dateTo)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { field: "date_2" }, {
                      header: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("content.researchEquipment.content.priceListPriceHeaderTitle")), 1)
                      ]),
                      body: _withCtx((slotProps) => [
                        _createTextVNode(_toDisplayString(slotProps.data.price) + " € ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ])
          ]),
          _hoisted_106,
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-iconEdge f-width",
                icon: "icon-chevron-right",
                "icon-pos": "right",
                label: _ctx.t('content.researchEquipment.content.bookEquipmentButton'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onBookEquipmentClick(_ctx.state.item1)))
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_109, [
              _createVNode(_component_Button, {
                type: "button",
                class: "p-button-iconEdge f-width",
                icon: "icon-chevron-right",
                "icon-pos": "right",
                label: _ctx.t('content.researchEquipment.content.bookEquipmentButton'),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onBookEquipmentClick(_ctx.state.item2)))
              }, null, 8, ["label"])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_component_Galleria, {
      visible: _ctx.state.showGallery1,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.showGallery1) = $event)),
      value: _ctx.state.images1,
      "num-visible": 6,
      "container-style": "max-width: 50%",
      circular: true,
      "full-screen": true,
      "show-item-navigators": true
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("img", {
          src: slotProps.item.url,
          alt: slotProps.item.alt,
          style: {"width":"800px","height":"533px","display":"block"}
        }, null, 8, _hoisted_110)
      ]),
      thumbnail: _withCtx((slotProps) => [
        _createElementVNode("img", {
          src: slotProps.item.url,
          alt: slotProps.item.alt,
          style: {"display":"block","max-height":"116px","max-width":"174px"}
        }, null, 8, _hoisted_111)
      ]),
      _: 1
    }, 8, ["visible", "value"]),
    _createVNode(_component_Galleria, {
      visible: _ctx.state.showGallery2,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.showGallery2) = $event)),
      value: _ctx.state.images2,
      "num-visible": 6,
      "container-style": "max-width: 50%",
      circular: true,
      "full-screen": true,
      "show-item-navigators": true
    }, {
      item: _withCtx((slotProps) => [
        _createElementVNode("img", {
          src: slotProps.item.url,
          alt: slotProps.item.alt,
          style: {"width":"800px","height":"533px","display":"block"}
        }, null, 8, _hoisted_112)
      ]),
      thumbnail: _withCtx((slotProps) => [
        _createElementVNode("img", {
          src: slotProps.item.url,
          alt: slotProps.item.alt,
          style: {"display":"block","max-height":"116px","max-width":"174px"}
        }, null, 8, _hoisted_113)
      ]),
      _: 1
    }, 8, ["visible", "value"]),
    _createVNode(_component_Prompt, {
      visible: _ctx.state.showLoginDialog,
      title: _ctx.t('content.login.header.title'),
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.showLoginDialog = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_114, [
          _createElementVNode("p", null, _toDisplayString(_ctx.t("content.login.content.text")), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.t("content.login.content.createUserAccountText")), 1),
            _hoisted_115,
            _createElementVNode("a", {
              href: "#",
              class: "link text-color-blue",
              onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => {
              _ctx.state.showLoginDialog = false;
              _ctx.state.showRegistrationDialog = true;
            }, ["prevent"]))
            }, _toDisplayString(_ctx.t("content.login.content.createUserAccountLink")), 1)
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "p-button-outlined",
          label: _ctx.t('content.globalCancelButton'),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.showLoginDialog = false))
        }, null, 8, ["label"]),
        _createVNode(_component_Button, {
          label: _ctx.t('content.login.footer.loginButton'),
          onClick: _ctx.onLoginRedirectClick
        }, null, 8, ["label", "onClick"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_Register, {
      show: _ctx.state.showRegistrationDialog,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.showRegistrationDialog = false))
    }, null, 8, ["show"])
  ], 64))
}